<template>
  <div
    class="mb-5"
    v-show="tab === activeTab"
    :id="`${tab}-tab`"
    :aria-labelledby="tab"
    role="tabpanel"
  >
    <ul>
      <ProviderCard
        v-for="item in quotes"
        :key="item.psp.slug"
        class="mt-7 lg:mt-8"
        :grouped-quotes="item"
        :is-active-tab="tab === activeTab"
        :mid-market-rate="midMarketRate"
      />
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { GroupedQuotes } from './types'
import ProviderCard from './provider-card.vue'
import type { PaymentType } from '@core/types/imt'

defineProps<{
  quotes: GroupedQuotes[]
  tab: PaymentType
  activeTab: PaymentType
  midMarketRate: number
  comparisonId: string
}>()
</script>
